import {sharedDropdownContent} from 'components/Dropdown/styles'

const notUnstyled = {
    '& hr': {
        backgroundColor: '$dropdownHrBorder',
        border: 'none',
        height: '1px',
    },
    'padding': '0.4rem',
}

export const styledDropdownContent = {
    ...sharedDropdownContent,
    'maxHeight': '60vh',
    'overflowY': 'auto',
    'variants': {
        direction: {
            'fixed-end': {
                left: 0,
                position: 'fixed',
                top: 0,
                visibility: 'hidden',
                zIndex: '$dropdown',
            },
            'fixed-right': {
                left: 0,
                position: 'fixed',
                top: 0,
                visibility: 'hidden',
                zIndex: '$dropdown',
            },
            'left': {
                left: 0,
                top: '2.1rem',
            },
            'right': {
                right: 0,
                top: '2.1rem',
            },

            'top-left': {
                bottom: '2.1rem',
                left: '0',
            },
            'top-right': {
                bottom: '2.1rem',
                right: '0',
            },
        },
        flavor: {
            'default': {...notUnstyled},
            'full-width': {
                ...notUnstyled,
                maxWidth: 'unset',
                width: '100%',
            },
            'unstyled': {
                maxWidth: 'unset',
                overflow: 'hidden',
            },
            'with-submenu': {
                ...notUnstyled,
                maxHeight: 'unset',
                overflow: 'visible',
            },
        },
        open: {false: {display: 'none'}},
    },
    'zIndex': '$dropdown',
    // eslint-disable-next-line sort-keys
    'button:disabled': {'& svg': {color: '$dropdownButtonIconDisabled'}},
}
